import {Box, useTheme} from "@material-ui/core"
import React from "react"

function ToolButtonGroup({onClick, children}) {
    const theme = useTheme()
    const buttons = onClick ? React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {onClick: child.props.onClick || onClick})
        } else {
            return child
        }
    }) : children
    const spacing = `${theme.spacing(1) / 2} + px`
    return (
        <Box display="flex" flexDirection="row" flexWrap={"wrap"} padding={spacing} style={{ gap: spacing }}>
            {buttons}
        </Box>
    )
}

export default ToolButtonGroup